import styled from 'styled-components';

const StyledWrapperHeader = styled.div`
  & > div {
    display: flex;
    align-items: center;
    height: 56px;
    @media screen and (min-width: 768px) {
      height: 72px;
    }
  }
`;

export default StyledWrapperHeader;
